import tippy from "tippy.js"

const hotspotsSection =  () => ({
  selectedVariant: null,
  productTitle: null,
  productVendor: null,
  productImage: null,
  productMinPrice: null,
  productUrl: null,
  variantUrl: null,
  variantImage: null,
  variantOptionName: null,
  productId: null,
  openDrawer: false,
  drawer: null,
  drawerWrapper: null,
  isMobile: false,
  ringingButtons: null,
  toolTip: null,
  toolTipsArray: [],
  init(){
    if (window.innerWidth <= 990){
      this.isMobile = true
    }

    window.addEventListener("resize", ()=>{
      this.isMobile = window.innerWidth <= 990;
    })
    if (!this.isMobile){
      this.initToolTip()
    }
  },
  getCurrentVariant(object){
    this.productId = object.product_id
    this.selectedVariant = object.variant
    this.productTitle = object.product_title
    this.productVendor = object.product_vendor
    this.productImage = object.product_image
    this.productUrl = object.product_url
    // this.productMinPrice = object.variant.compare_at_price || object.product_min_price
    this.productMinPrice = object.product_min_price
    this.variantImage = this.selectedVariant.featured_image.src || this.productImage
    this.variantUrl = this.productUrl + `?variant=${this.selectedVariant.id}`
    this.variantOptionName = object.variant_option_name
    if (this.selectedVariant){
      document.querySelector("body").classList.add("overflow-scroll")
      document.querySelector("html").classList.add("overflow-hidden")
      document.querySelector("html").classList.add("max-h-screen")
    }
    this.openDrawer = true
  },
  closeMobileDrawer() {
    window.dispatchEvent(new Event('close-drawer'));
    this.removeDrawerEventListener();
    document.querySelector("body").classList.remove("overflow-scroll")
    document.querySelector("html").classList.remove("overflow-hidden")
    document.querySelector("html").classList.remove("max-h-screen")
  },
  setDrawerListeners() {

    this.drawer = this.$el;

    this.drawerWrapper = this.drawer.querySelector('.variant-drawer__wrapper-inner');
    const bottomSheetHandle = this.drawer.querySelector('.variant-drawer__header');

    if (bottomSheetHandle && this.drawerWrapper) {
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);

      bottomSheetHandle.addEventListener('touchstart', this.onTouchStart);
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('touchend', this.onTouchEnd);
    }
  },
  onTouchStart(event) {
    this.startDrag(event, event.touches[0].clientY);
  },
  onTouchMove(event) {
    this.drag(event, event.touches[0].clientY);
  },
  onTouchEnd(event) {
    this.endDrag(event, event.changedTouches[0].clientY);
  },
  startDrag(event, clientY) {
    this.isDragging = true;
    this.startY = clientY;
    const style = window.getComputedStyle(this.drawer);
    const matrix = new DOMMatrixReadOnly(style.transform);
    this.initialTranslateY = matrix.m42;
    this.drawer.classList.add('is-dragging');
  },
  drag(event, clientY) {

    if (!this.isDragging) {
      return null;
    }

    const deltaY = clientY - this.startY;
    const newTranslateY = Math.max(this.initialTranslateY + deltaY, 0);
    this.drawerWrapper.style.transform = `translateY(${newTranslateY}px)`;

  },
  endDrag(event, clientY) {

    if (!this.isDragging) {
      return null;
    }

    const deltaY = clientY - this.startY;

    this.drawer.classList.remove('is-dragging');
    this.drawerWrapper.style.transform = '';

    if (deltaY > 80) {
      this.closeMobileDrawer();
      this.removeDrawerEventListener();
    }


    this.isDragging = false;
  },
  removeDrawerEventListener() {
    document.removeEventListener('touchmove', this.onTouchMove);
    document.removeEventListener('touchend', this.onTouchEnd);
  },
  initToolTip(){
    this.ringingButtons = document.querySelectorAll(".button-container")

    if (this.ringingButtons){
      this.ringingButtons.forEach(button => {
        this.toolTip = tippy(button, {
          content(reference) {
            const id = reference.getAttribute('data-template');
            if (id){
              const template = document.getElementById(id);
              return template.innerHTML;
            }
          },
          allowHTML: true,
          interactive: true,
          placement: 'bottom',
          onTrigger(instance) {
            setTimeout(()=>{
              window._swat?.initializeActionButtons("body")
            }, 100)
          }
        });
        this.toolTipsArray.push(this.toolTip)
      })
    }
  },
})


export default hotspotsSection;

window.addEventListener("alpine:init", ()=>{
  Alpine.data("hotspotsSection", hotspotsSection);
})
